(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CATEGORIES-SHOWCASE"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCategoryShowcase(root) {
    if (!root || root.dataset.categoryShowcaseInit === 'true') return;
    root.dataset.categoryShowcaseInit = 'true';

    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-category-nav-item]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-category-image]'));
    if (!navItems.length || !images.length) return;

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;
    var activeIndex = 0;

    function setActive(index) {
      if (index === activeIndex && navItems[index] && navItems[index].classList.contains('is-active')) return;
      activeIndex = index;

      navItems.forEach(function (item) {
        var isActive = parseInt(item.dataset.index, 10) === index;
        item.classList.toggle('is-active', isActive);

        if (item.tagName === 'A') {
          if (isActive) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        } else {
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      images.forEach(function (image) {
        var isActive = parseInt(image.dataset.index, 10) === index;
        image.classList.toggle('is-active', isActive);
        image.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || navItems.length < 2) return;
      stopAutoplay();
      timer = setInterval(function () {
        setActive((activeIndex + 1) % navItems.length);
      }, autoplaySpeed);
    }

    navItems.forEach(function (item, position) {
      var index = parseInt(item.dataset.index, 10);

      item.addEventListener('mouseenter', function () {
        setActive(index);
        stopAutoplay();
      });

      // Links navigate on click; buttons only swap the image.
      item.addEventListener('click', function () {
        setActive(index);
        stopAutoplay();
      });

      item.addEventListener('focus', function () {
        setActive(index);
        stopAutoplay();
      });

      item.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (position + 1) % navItems.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (position - 1 + navItems.length) % navItems.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = navItems.length - 1;
        if (next === null) return;
        event.preventDefault();
        stopAutoplay();
        navItems[next].focus();
      });
    });

    root.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else if (root.isConnected) {
        startAutoplay();
      }
    });

    root.categoryShowcaseSetActive = setActive;
    root.categoryShowcaseStop = stopAutoplay;
    root.categoryShowcaseStart = startAutoplay;
    root.categoryShowcaseDestroy = function () {
      stopAutoplay();
      root.dataset.categoryShowcaseInit = 'false';
    };

    startAutoplay();
  }

  function initAll(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll('[data-category-showcase]');
    Array.prototype.forEach.call(sections, initCategoryShowcase);
    if (scope.matches && scope.matches('[data-category-showcase]')) initCategoryShowcase(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-category-showcase]');
    if (root && typeof root.categoryShowcaseDestroy === 'function') root.categoryShowcaseDestroy();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-category-showcase]');
    if (!root || typeof root.categoryShowcaseSetActive !== 'function') return;
    root.categoryShowcaseStop();
    root.categoryShowcaseSetActive(parseInt(event.target.dataset.index, 10) || 0);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-category-showcase]');
    if (root && typeof root.categoryShowcaseStart === 'function') root.categoryShowcaseStart();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
